<template>
	<div class="display_wrapper">

		<div grey-back full-height id="non-printable-area" v-if="displayData">

			<v-toolbar flat fixed>	
				<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				<v-toolbar-title class="white--text">Expense Category</v-toolbar-title>

				<v-spacer></v-spacer>

				<v-btn icon @click="fn_edit" v-if="displayData && !displayData.isSystem">
					<v-icon>edit</v-icon>
				</v-btn>

				<v-btn icon @click="fn_getBottomMenu">
					<v-icon>more_vert</v-icon>
				</v-btn>
			</v-toolbar>

			<div class="display hasToolbar">
				<div class="display_title">{{displayData.name}}</div>

				<!-- <v-list class="section-container" two-line>
					<v-subheader light>Details</v-subheader>
					<v-divider></v-divider>
					<div>
						<v-list-tile>
							<v-list-tile-content>
								<v-list-tile-title>Ledger</v-list-tile-title>
								<v-list-tile-sub-title>{{displayData.accountLedgerName}}</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</div>
				</v-list> -->

				<v-tabs v-model="activeIndex" slider-color="primary">
					<v-tab v-for="(tab, index) in tabs" :key="index" ripple>{{tab.title}}</v-tab>
				</v-tabs>

				<v-tabs-items v-model="activeIndex">
					<v-tab-item>  
						<activity-tab ref="ref_activity" :expenseCategoryId="displayData.expenseCategoryId" :preview="fn_preview" :bindInvoiceTemplate="fn_bindInvoiceTemplate" v-if="displayData"></activity-tab>
					</v-tab-item>
					<v-tab-item>  
						<details-tab ref="ref_details" :data="displayData" v-if="displayData"></details-tab>
					</v-tab-item>
				</v-tabs-items>
			</div>

		</div>

		<dialog-confirmation ref="ref_dialogDeleteConfirmation" header="Delete Master?" :actionMethod="fn_deleteMaster" params="delete" :displayView='true'></dialog-confirmation>

		<payment-reminder-card></payment-reminder-card>

		<div white-background id="printable" full-width>
	      <component :is="printTemplate" ref="ref_printTemplate" :data="printData" v-if="printTemplate && printData!=null"></component>
	    </div>

	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
import {masterMixin} from '../../master_mixin.js'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import paymentReminderCard from '../../../common/payment_reminder_card'
import {transactionMixin} from '../../../transactions/transaction_mixin'

import activityTab from './display_tabs/activity'
import detailsTab from './display_tabs/details'

	export default{
		mixins: [masterMixin, transactionMixin],
		data(){
			return{
				displayData:null,
				tabs:[
					{"id":1, "title":"Activity"},
		            {"id":2, "title":"Details"}
		        ],
				activeIndex:0,
				offsetTop: 0,
		        fixedTabs:false,
				printData:null,
        		printTemplate:null,
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation,
			'activity-tab': activityTab,
			'details-tab': detailsTab,
			'payment-reminder-card':paymentReminderCard
		},
		methods:{

			fn_get: function(itemId){
				var self = this;
		  		this.getData('ExpenseCategory', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.displayData = JSON.parse(response);
						//   self.fn_loadItems();
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Expense Category";
				viewObject.TopMenu = [menuItem.edit];
				viewObject.isBottomMenu = true;

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_getBottomMenu: function (tagId) {
				var bottomMenu = {"BottomMenu": [menuItem.copy]};
				!this.displayData.isSystem ? bottomMenu.BottomMenu.push(menuItem.delete) : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.expenseCategoryId){
					this.fn_edit();
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/masters/expensecategory/items/new', query:{tagId:this.guidWeb(), itemId:this.displayData.expenseCategoryId, copy:true}});
				}
				else if(menuAction=='delete'){
					this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = true;
				}
			},

			fn_deleteMaster: function(){
				let self = this;
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				this.fn_deleteMasterItem('expenseCategory', this.displayData.expenseCategoryId, function(response){
					if(response){
                        self.showToast('Item deleted');
                        self.$router.go(-1);
                    }
                    else{
                        self.showToast("Item cannot be deleted as already in use");
                    }
				})
			},

			fn_edit: function () {
				this.$router.push("/masters/expensecategory/items/"+this.displayData.expenseCategoryId+"/edit");
			},

			// fn_loadItems: function() {
			// 	this.loadMore = true;
		    // 	let filterObject = {};
			// 	filterObject.expenseCategoryId = this.displayData.expenseCategoryId;
			// 	filterObject.limit = 50;
			// 	filterObject.startIndex = 0;
			// 	filterObject.search = '';

			// 	let self = this;
			// 	this.getItems("ExpenseCategoryActivities", filterObject, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
		    // },

			fn_preview: function(item, formNameFn){
		        item.toolbarTitle = formNameFn ? formNameFn(item.transactionListId) : 'order';
		        let printType = item.invoiceTemplate == 101 ? 'ab' : item.invoiceTemplate == 201 ? 'sj' : null;

		        let type = null;
		        if(item.transactionListId == 10001 || item.transactionListId == 10002 || item.transactionListId == 10003 || item.transactionListId == 10004 || item.transactionListId == 10005){
		          type = 'sales';
		        }
		        else if(item.transactionListId == 20001 || item.transactionListId == 20002 || item.transactionListId == 20003 || item.transactionListId == 20004 || item.transactionListId == 20005){
		          type = 'purchase';
		        }
		        else if(item.transactionListId == 40002){
		          type = 'inventory';
		        }
		        
		        this.fn_previewInvoice(true, type, printType, item);
		    },

		    fn_bindInvoiceTemplate: function(type, item){

		        this.printTemplate = null;
		        this.printData = null;
		        // this.printableType = 1;

		        this.printTemplate = require('../../../invoice_templates/invoices/template'+item.invoiceTemplate).default;
		        console.log(this.printTemplate);

		        let dataFnName = item.invoiceTemplate == 101 ? 'AccountBookPrintData' : item.invoiceTemplate == 201 ? 'StockJournalPrintData' : 'InvoiceData';

		        if(type=='sharewhatsapp'){
		          this.fn_shareInvoice('sharewhatsapp', item, dataFnName);
		        }
		        else if(type=='print'){
		          this.fn_getPrintData(dataFnName, item.transactionId, 'print', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }
		        else if(type=='pdf'){
		          this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }
		        else if(type=='share'){
		          this.fn_shareInvoice('share', item, dataFnName);
		        }

		        // let self = this;
		        // setTimeout(function(){
		        // 	self.printableType = null;
		        // },10000);
		    },

		    fn_shareInvoice: function(type, item, dataFnName){

		    	let title = null;
		        if(item.transactionListId==10003){
		            title = "Invoice";
		        }
		        else{
		            title = this.fn_getTransactionTitle(item.transactionListId);    
		        }
        
		        let shareObj = {};
		        shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
		        shareObj.type = 'pdf';
		        shareObj.primaryMobileNumber = item.primaryMobileNumber && type == 'sharewhatsapp' ? item.primaryMobileNumber : null;
				shareObj.subject = title + " #" + item.mergeTransactionNumber + " from " + this.$root.CurrentBusiness.BusinessName;
		        shareObj.email = item.email ? [item.email] : null ;
		        let party = item.partyName ? item.partyName + ',' : '';
				shareObj.textMessage = this.$tShare('share.invoiceMessage', {
					party: party,
					title: title,
					number: item.mergeTransactionNumber,
					date: this.$moment(item.transactionDate).format('DD-MMM-YYYY'),
					amount: this.$root.numberToLocale(item.roundedAmount),
					businessName: this.$root.CurrentBusiness.BusinessName
				});
		        this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', shareObj, item.mergeTransactionNumber, null, item.transactionListId);
		    },

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		mounted: function(){
			this.fn_showWebView();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_goBack = this.fn_goBack;
	        
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation){
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/expense_categories/display.vue